<template>
  <div :id="componentId" class="spm1-media" :style="{ backgroundImage: `url(${backgroundImage})` }">
    <div class="spm1-media-grid">
      <a
        v-for="(item, idx) in items"
        :key="idx"
        :class="['spm1-media-item', { 'is-link': item.jumpType === 2 }]"
        href="javascript:;"
        @click.prevent="handleClick(item)"
      >
        <img class="spm1-media-logo" referrerpolicy="no-referrer" :src="item.imageUrl" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileMediaCooperation',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_15'
    }
  },
  data() {
    return {
      backgroundImage: require('../../../special/SpecialOne/assets/img/bottom_bg.png'),
      items: [
        { imageUrl: require('../../../special/SpecialOne/assets/img/media_1.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/media_2.png'), jumpType: 2, linkAddress: 'https://www.example.com/media/2' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/media_3.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/media_4.png'), jumpType: 2, linkAddress: 'https://www.example.com/media/4' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/media_5.png'), jumpType: 1, linkAddress: '' },
        { imageUrl: require('../../../special/SpecialOne/assets/img/media_6.png'), jumpType: 2, linkAddress: 'https://www.example.com/media/6' }
      ]
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return
      window.open(item.linkAddress, '_blank')
    }
  }
}
</script>

<style scoped>
.spm1-media {
  width: 100%;
  padding: 16px 12px;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.spm1-media-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.spm1-media-item {
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border: 1px dashed rgba(238, 238, 238, 1);
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
}

.spm1-media-item.is-link {
  cursor: pointer;
}

.spm1-media-item.is-link:active {
  opacity: 0.9;
}

.spm1-media-logo {
  max-width: 80%;
  max-height: 40px;
  object-fit: contain;
}
</style>
